import { render, staticRenderFns } from "./TabHeaders.vue?vue&type=template&id=e3f1c37a&"
import script from "./TabHeaders.vue?vue&type=script&lang=js&"
export * from "./TabHeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports